<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#/toko">TOKO</a></li>
                <li><a href="#/toko_dashboard">DASHBOARD</a></li>
                <!-- <li class="active">Region</li> -->
            </ol>
        </section>
            <!-- Main content -->
            <section class="content">
                <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-left" style="padding-left: 20px; padding-top: 10px;">
                          DASHBOARD
                          <h4><b v-if="this.data">{{this.nama_toko}} ({{this.tahun}})</b></h4>
                        </div>
                        <div class="pull-right" style="padding-right: 20px; padding-top: 5px;">
                          <!-- <el-select v-model="toko1" clearable filterable placeholder="Pilih Toko" style="width: 500px" @change="handleSelect1">
                            <el-option
                              v-for="item in region"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                          <el-date-picker @change='handleChangeDate' v-model="value4" type="month" style="width: 120px" placeholder="Pilih Bulan"></el-date-picker>
                          &nbsp;
                          <el-button v-loading.fullscreen.lock="fullscreenLoading" icon="el-icon-search" @click="getData()" circle></el-button>                           -->
                          <el-button icon="el-icon-search" v-loading.fullscreen.lock="fullscreenLoading" @click="filterData()" circle></el-button>
                        </div>
                        <!-- <div style="padding-left: 20px; padding-right: 20px;">
                            <el-row>
                                <el-col :span="24">
                                    <h4><b>DASHBOARD</b></h4></el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                  <el-select v-model="toko1" clearable filterable placeholder="Pilih Toko"
                                      @change="handleSelect1">
                                    <el-option
                                      v-for="item in region"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value">
                                    </el-option>
                                  </el-select>
                               </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-date-picker @change='handleChangeDate' v-model="value4" type="month" placeholder="Pilih Bulan"></el-date-picker>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-button type="success" icon="el-icon-search" v-loading.fullscreen.lock="fullscreenLoading" @click="getData()">Tampilkan Data</el-button>
                                </el-col>
                            </el-row>
                        </div> -->
                    </div>
                    <div class="box-body">

                      <el-row>
                        <el-col :span="24" style="padding: 5px">
                          <div class="box palette-Indigo-900 bg">
                              <div class="box-header  palette-Indigo-900 bg">
                                  <!-- tools box -->
                                  <div class="pull-right text-white box-tools">
                                      <span class="text-white box-btn">
                                        <i class="circle-nest-medium dripicons-cart"></i>
                                      </span>&nbsp;&nbsp;&nbsp;
                                  </div>
                                  <h3 class="box-title">
                                    <span class="text-white">&nbsp;&nbsp;&nbsp;SALES</span>
                                  </h3>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body no-pad" style="display: block; padding: 0px !important;">
                                  <div class="events-nest">
                                      <div class="wrap-no-pad text-white">
                                          <h2 style="color: white; word-break: break-all;" class="text-white">
                                            <strong v-if="data.sales_all">{{ data.sales_all.replace(/\.00$/,'') + ' (' + data.total_days + ' Hari)' }}</strong>
                                          </h2>
                                          <br>
                                      </div>
                                  </div>
                              </div>
                              <!-- /.box-body -->
                          </div>
                        </el-col>
                        <el-col :span="24" style="padding: 5px">
                          <div class="box palette-Indigo-900 bg">
                              <div class="box-header  palette-Indigo-900 bg">
                                  <!-- tools box -->
                                  <div class="pull-right text-white box-tools">
                                      <span class="text-white box-btn">
                                        <i class="circle-nest-medium dripicons-graph-line"></i>
                                      </span>&nbsp;&nbsp;&nbsp;
                                  </div>
                                  <h3 class="box-title">
                                    <span class="text-white">&nbsp;&nbsp;&nbsp;SALES AVG</span>
                                  </h3>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body no-pad" style="display: block; padding: 0px !important;">
                                  <div class="events-nest">
                                      <div class="wrap-no-pad text-white">
                                          <h2 style="color: white; word-break: break-all;" class="text-white">
                                            <strong v-if="data.sales_avg">{{ data.sales_avg.replace(/\.00$/,'') }}</strong>
                                          </h2>
                                          <br>
                                      </div>
                                  </div>
                              </div>
                              <!-- /.box-body -->
                          </div>
                          
                        </el-col>
                      </el-row>

                      <el-row>
                        <el-col :span="24" style="padding: 5px">
                          <div class="box palette-Teal-900 bg">
                              <div class="box-header  palette-Teal-900 bg">
                                  <!-- tools box -->
                                  <div class="pull-right text-white box-tools">
                                      <span class="text-white box-btn">
                                        <i class="circle-nest-medium dripicons-basket"></i>
                                      </span>&nbsp;&nbsp;&nbsp;
                                  </div>
                                  <h3 class="box-title">
                                    <span class="text-white">&nbsp;&nbsp;&nbsp;COGS BULANAN</span>
                                  </h3>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body no-pad" style="display: block; padding: 0px !important;">
                                  <div class="events-nest">
                                      <div class="wrap-no-pad text-white">
                                          <h2 style="color: white; word-break: break-all;" class="text-white">
                                            <strong v-if="data.cogs_bulanan">{{ data.cogs_bulanan.replace(/\.00$/,'') + ' (' + parseFloat((parseFloat(data.cogs_bulanan.replace(/,/g, '')) / parseFloat(data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/,'') + '%)'}}</strong>
                                          </h2>
                                          <br>
                                      </div>
                                  </div>
                              </div>
                              <!-- /.box-body -->
                          </div>
                        </el-col>
                        <el-col :span="24" style="padding: 5px">
                          <div class="box palette-Teal-900 bg">
                              <div class="box-header palette-Teal-900 bg">
                                  <!-- tools box -->
                                  <div class="pull-right text-white box-tools">
                                      <span class="text-white box-btn">
                                        <i class="circle-nest-medium dripicons-basket"></i>
                                      </span>&nbsp;&nbsp;&nbsp;
                                  </div>
                                  <h3 class="box-title">
                                    <span class="text-white">&nbsp;&nbsp;&nbsp;COGS HARIAN</span>
                                  </h3>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body no-pad" style="display: block; padding: 0px !important;">
                                  <div class="events-nest">
                                      <div class="wrap-no-pad text-white">
                                          <h2 style="color: white; word-break: break-all;" class="text-white">
                                            <strong v-if="data.cogs_harian">{{ data.cogs_harian.replace(/\.00$/,'') + ' (' + parseFloat((parseFloat(data.cogs_harian.replace(/,/g, '')) / parseFloat(data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/,'') + '%)'}}</strong>
                                          </h2>
                                          <br>
                                      </div>
                                  </div>
                              </div>
                              <!-- /.box-body -->
                          </div>
                          
                        </el-col>
                      </el-row>

                      <el-row>
                        <el-col :span="24" style="padding: 5px">
                          <div class="box palette-Cyan-700 bg">
                              <div class="box-header palette-Cyan-700 bg">
                                  <!-- tools box -->
                                  <div class="pull-right text-white box-tools">
                                      <span class="text-white box-btn">
                                        <i class="circle-nest-medium dripicons-basket"></i>
                                      </span>&nbsp;&nbsp;&nbsp;
                                  </div>
                                  <h3 class="box-title">
                                    <span class="text-white">&nbsp;&nbsp;&nbsp;COST BULANAN</span>
                                  </h3>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body no-pad" style="display: block; padding: 0px !important;">
                                  <div class="events-nest">
                                      <div class="wrap-no-pad text-white">
                                          <h2 style="color: white; word-break: break-all;" class="text-white">
                                            <strong v-if="data.opr_bulanan">{{ data.opr_bulanan.replace(/\.00$/,'') + ' (' + parseFloat((parseFloat(data.opr_bulanan.replace(/,/g, '')) / parseFloat(data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/,'') + '%)' }}</strong>
                                          </h2>
                                          <br>
                                      </div>
                                  </div>
                              </div>
                              <!-- /.box-body -->
                          </div>
                        </el-col>
                        <el-col :span="24" style="padding: 5px">
                          <div class="box palette-Cyan-700 bg">
                              <div class="box-header palette-Cyan-700 bg">
                                  <!-- tools box -->
                                  <div class="pull-right text-white box-tools">
                                      <span class="text-white box-btn">
                                        <i class="circle-nest-medium dripicons-basket"></i>
                                      </span>&nbsp;&nbsp;&nbsp;
                                  </div>
                                  <h3 class="box-title">
                                    <span class="text-white">&nbsp;&nbsp;&nbsp;COST HARIAN</span>
                                  </h3>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body no-pad" style="display: block; padding: 0px !important;">
                                  <div class="events-nest">
                                      <div class="wrap-no-pad text-white">
                                          <h2 style="color: white; word-break: break-all;" class="text-white">
                                            <strong v-if="data.opr_harian">{{ data.opr_harian.replace(/\.00$/,'') + ' (' + parseFloat((parseFloat(data.opr_harian.replace(/,/g, '')) / parseFloat(data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/,'') + '%)' }}</strong>
                                          </h2>
                                          <br>
                                      </div>
                                  </div>
                              </div>
                              <!-- /.box-body -->
                          </div>
                          
                        </el-col>
                      </el-row>

                      <el-row>
                        <el-col :span="24" style="padding: 5px">
                          <div class="box palette-Red-900 bg">
                              <div class="box-header  palette-Red-900 bg">
                                  <!-- tools box -->
                                  <div class="pull-right text-white box-tools">
                                      <span class="text-white box-btn">
                                        <i class="circle-nest-medium dripicons-trash"></i>
                                      </span>&nbsp;&nbsp;&nbsp;
                                  </div>
                                  <h3 class="box-title">
                                    <span class="text-white">&nbsp;&nbsp;&nbsp;WASTE</span>
                                  </h3>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body no-pad" style="display: block; padding: 0px !important;">
                                  <div class="events-nest">
                                      <div class="wrap-no-pad text-white">
                                          <h2 style="color: white; word-break: break-all;" class="text-white">
                                            <strong v-if="data.waste">{{ data.waste.replace(/\.00$/,'') + ' (' + parseFloat((parseFloat(data.waste.replace(/,/g, '')) / parseFloat(data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/,'') + '%)'}}</strong>
                                          </h2>
                                          <br>
                                      </div>
                                  </div>
                              </div>
                              <!-- /.box-body -->
                          </div>
                        </el-col>
                        <el-col :span="24" style="padding: 5px">
                          <div class="box palette-Deep-Orange-900 bg">
                              <div class="box-header  palette-Deep-Orange-900 bg">
                                  <!-- tools box -->
                                  <div class="pull-right text-white box-tools">
                                      <span class="text-white box-btn">
                                        <i class="circle-nest-medium dripicons-pulse"></i>
                                      </span>&nbsp;&nbsp;&nbsp;
                                  </div>
                                  <h3 class="box-title">
                                    <span class="text-white">&nbsp;&nbsp;&nbsp;NET PROFIT</span>
                                  </h3>
                              </div>
                              <!-- /.box-header -->
                              <div class="box-body no-pad" style="display: block; padding: 0px !important;">
                                  <div class="events-nest">
                                      <div class="wrap-no-pad text-white">
                                          <h2 style="color: white; word-break: break-all;" class="text-white">
                                            <strong v-if="data.sales_all">{{ toMoney(parseFloat( parseFloat(data.sales_all.replace(/,/g, '')) - parseFloat( parseFloat(data.opr_bulanan.replace(/,/g, '')) + parseFloat(data.opr_harian.replace(/,/g, '')) + parseFloat(data.cogs_bulanan.replace(/,/g, '')) + parseFloat(data.cogs_harian.replace(/,/g, ''))) )) + ' (' + parseFloat((parseFloat( parseFloat(data.sales_all.replace(/,/g, '')) - parseFloat( parseFloat(data.opr_bulanan.replace(/,/g, '')) + parseFloat(data.opr_harian.replace(/,/g, '')) + parseFloat(data.cogs_bulanan.replace(/,/g, '')) + parseFloat(data.cogs_harian.replace(/,/g, ''))) ) / parseFloat(data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/,'') + '%)'}}</strong>
                                          </h2>
                                          <br>
                                      </div>
                                  </div>
                              </div>
                              <!-- /.box-body -->
                          </div>
                          
                        </el-col>
                      </el-row>

                      <!-- <el-row>
                        <el-col :span="24" style="padding: 5px">
                          <ve-bar :data="chartDataBar" :settings="chartSettingsBar"></ve-bar>
                        </el-col>
                      </el-row> -->

                      <el-row v-if="this.data">
                        <el-col :span="24" style="padding: 5px">
                          <ve-histogram :data="chartDataHistogram" :settings="chartSettingsHistogram"></ve-histogram>
                        </el-col>
                      </el-row>
                      
                      <el-row v-if="this.data && this.kode_toko.indexOf(',') < 0">
                        <el-col :span="24" style="padding: 5px">
                          <el-alert title="Data didapatkan dari Pegawai yang melakukan ABSENSI di bulan terpilih" type="info" :closable="false"></el-alert><br />
                          <el-table v-loading="loadingModal"  border hover
                            :data="pegawaiData"
                            style="width: 100%" responsive>
                            <el-table-column
                              prop="nama"
                              label="PEGAWAI">
                            </el-table-column>
                            <el-table-column
                              prop="level"
                              label="LEVEL"
                              width="200px">
                            </el-table-column>
                          </el-table>
                          <br />
                          <el-alert title="Dihitung dengan rumus :" type="info" 
                          description="Qty Aktual Terjual / Qty Terjual Menurut Ingredient"
                          :closable="false"></el-alert><br />
                          <el-table v-loading="loadingModal"  border hover
                            :data="rasioData"
                            style="width: 100%" responsive>
                            <el-table-column
                              prop="nama"
                              label="BARANG">
                            </el-table-column>
                            <el-table-column
                              prop="prosentase"
                              label="% RASIO"
                              header-align="center"
                              align="center"
                              width="100px">
                            </el-table-column>
                          </el-table>
                        </el-col>
                        <el-col :span="24" style="padding: 5px">
                          <ve-pie :data="chartData" :settings="chartSettings" style="width: 100%; heigth: 100%"></ve-pie>
                        </el-col>
                      </el-row>
                    </div>
                </div>
                <!-- End of Basic Tables-->
                <!-- Default box -->
                <!-- <div class="row">
									<div class="col-md-12">
										<div class="box">
											<div class="box-header"></div>
											<div class="box-body">
												<ve-line style="width:100%" :data="chartData" :settings="chartSettings"></ve-line>
											</div>
										</div>
									</div>
								</div> -->
                <!-- /.box-body -->
            
              <el-dialog title="Filter Data" :visible.sync="dialogFormFilter" v-loading="loadingModalFilter" :close-on-click-modal="false" width="99%" top="1%">
                <el-form status-icon :rules="rules3" ref="formFilter" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                  <el-form-item label="Pilih Region" prop="region" v-if="this.region.length > 0">
                    <el-select v-model="regionSelected" clearable filterable placeholder="Pilih Region" style="width: 100%" @change="cbPilihRegion">
                      <el-option
                        v-for="item in region"
                        :key="item.value"
                        :label="item.label"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Pilih Wilayah" prop="wilayah" v-if="this.wilayah.length > 0">
                    <el-select v-model="wilayahSelected" clearable filterable placeholder="Pilih Wilayah" style="width: 100%" @change="cbPilihWilayah">
                      <el-option
                        v-for="item in wilayah"
                        :key="item.value"
                        :label="item.label"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Pilih Area" prop="area" v-if="this.area.length > 0">
                    <el-select v-model="areaSelected" clearable filterable placeholder="Pilih Area" style="width: 100%" @change="cbPilihArea">
                      <el-option
                        v-for="item in area"
                        :key="item.value"
                        :label="item.label"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Pilih Cabang" prop="cabang" v-if="this.cabang.length > 0">
                    <el-select v-model="cabangSelected" clearable filterable placeholder="Pilih Cabang" style="width: 100%" @change="cbPilihCabang">
                      <el-option
                        v-for="item in cabang"
                        :key="item.value"
                        :label="item.label"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Pilih Toko" prop="toko" v-if="this.toko.length > 0">
                    <el-select v-model="tokoSelected" clearable filterable placeholder="Pilih Toko" style="width: 100%" @change="cbPilihToko">
                      <el-option
                        v-for="item in toko"
                        :key="item.value"
                        :label="item.label"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>                          
                  <el-form-item label="Periode" prop="tanggal">
                    <el-date-picker @change='handleChangeDate' v-model="value4" type="month" style="width: 120px" placeholder="Pilih Bulan" align="right"></el-date-picker>
                    <!-- <el-date-picker
                      style="width: 250px"
                      type="month"
                      align="right"
                      v-model="value4"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      range-separator="-"
                      start-placeholder="Awal"
                      end-placeholder="Akhir">
                    </el-date-picker> -->
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogFormFilter = false">Batal</el-button>
                  <el-button type="primary" @click="getData()" v-if="this.kode_toko.length > 0">Tampilkan</el-button>
                </span>
              </el-dialog>

            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'Vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import VueCookie from 'vue-cookie'
    import moment from 'moment'
    Vue.use(VueCookie)

    import jsonUrl from '../../../assets/url.json'

    Vue.use(VueResource)

    export default {
      name: 'Wilayah',
      components: {
        ClipLoader
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama wilayah'))
          } else {
            callback()
          }
        }
        var validateArea = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama area'))
          } else {
            callback()
          }
        }
        return {
          chartDataBar: {
            columns: ['value', 'percent', 'label'],
            rows: [
              { 'value': 100000, 'percent': 100, 'label': 'SALES' }
              // ,
              // { 'label': 'COGS', 'value': 100000, 'percent': 100 },
              // { 'label': 'GROSS PROFIT', 'value': 100000, 'percent': 100 },
              // { 'label': 'EXPENSES', 'value': 100000, 'percent': 100 },
              // { 'label': 'NET PROFIT', 'value': 100000, 'percent': 100 },
              // { 'label': 'WASTE', 'value': 100000, 'percent': 100 }
            ]
          },
          chartSettingsBar: {
            dimension: ['label'],
            metrics: ['value'],
            label: {
              normal: {
                show: true,
                position: 'inside',
                formatter: ['percesnt']
              }
            }
          },
          chartDataHistogram: {
            columns: ['tgl', 'Penjualan', 'Penjualan Bln Sebelumnya'],
            rows: []
          },
          chartSettingsHistogram: {
            metrics: ['Penjualan', 'Penjualan Bln Sebelumnya'],
            showLine: ['Penjualan Bln Sebelumnya'],
            label: {
              normal: { show: true, position: 'inside' }
            }
          },
          chartDataOri: {
            columns: ['nama', 'total'],
            rows: [
              { 'Label': 'AYAM', 'Nilai': 0 },
              { 'Label': 'NON AYAM', 'Nilai': 0 },
              { 'Label': 'MINUMAN', 'Nilai': 0 }
            ]
          },
          chartData: {
            columns: ['nama', 'total'],
            rows: []
          },
          chartSettings: {
            dimension: 'nama',
            metrics: 'total'
          },
          options: [{
            value: 'Option1',
            label: 'Option1'
          }, {
            value: 'Option2',
            label: 'Option2'
          }, {
            value: 'Option3',
            label: 'Option3'
          }, {
            value: 'Option4',
            label: 'Option4'
          }, {
            value: 'Option5',
            label: 'Option5'
          }],
          dataTree: [{
            label: 'Ayam 70%',
            children: [{
              label: 'Ori 50%'
            }, {
              label: 'Pedas 50%'
            }]
          }, {
            label: 'Non-Ayam 25%'
          }, {
            label: 'Drink 5%',
            children: [{
              label: 'Teh 30%'
            }, {
              label: 'Yogurt 20%'
            }, {
              label: 'Aqua 50%'
            }]
          }],
          defaultProps: {
            children: 'children',
            label: 'label'
          },
          state1: '',
          data: '',
          chartData1: '',
          chartSettings1: '',
          value4: new Date(),
          value5: new Date(),
          value6: '',
          toko1: '',
          bulan: '',
          tahun: '',
          row1: {kode: '', nama: '', edit: true},
          tableData: [],
          tableData1: [],
          tableData2: [],
          pegawaiData: [],
          rasioData: [],
          rules: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ]
          },
          rules2: {
            area: [
              { validator: validateArea, trigger: 'blur' }
            ]
          },
          cari_nama: '',
          cari_tanggal: '',
          cari_penjualan: '',
          cari_pengeluaran_cogs: '',
          cari_pengeluaran_opr: '',
          cari_uang_setor: '',
          cari_lunas: '',
          nama: '',
          tanggal: '',
          nominal: '',
          kode_region: '',
          kode_wilayah: '',
          kode_area: '',
          kode_cabang: '',
          kode_toko: '',
          region: [],
          wilayah: [],
          area: [],
          cabang: [],
          toko: [],
          namas: [],
          pegawai: [],
          coba: false,
          dialogFormEdit: false,
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormArea: false,
          dialogFormFilter: false,
          loadingModalFilter: false,
          loadingModal: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalArea: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          dialogFormInfo: false,
          dialogFormLunas: false,
          loadingModalLunas: false,
          fullscreenLoading: false,
          form: {
            kode: '',
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            name: ''
          },
          form2: {
            kode: '',
            name: '',
            area: ''
          },
          message: '',
          formLabelWidth: 'auto',
          rules3: {
            nama: [
              { required: true, message: 'Silahkan isi nama device', trigger: 'blur' }
            ]
          },
          listQuery: {
            page: 1,
            limit: 20,
            importance: undefined,
            title: undefined,
            type: undefined,
            sort: 'none'
          },
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Nama A-Z', key: '+nama' }, { label: 'Nama Z-A', key: '-nama' }],
          total: null,
          page_size: 10,
          current_page: 1,
          linksCb: [
            { 'value': 'vue', 'link': 'https://github.com/vuejs/vue' },
            { 'value': 'element', 'link': 'https://github.com/ElemeFE/element' },
            { 'value': 'cooking', 'link': 'https://github.com/ElemeFE/cooking' },
            { 'value': 'mint-ui', 'link': 'https://github.com/ElemeFE/mint-ui' },
            { 'value': 'vuex', 'link': 'https://github.com/vuejs/vuex' },
            { 'value': 'vue-router', 'link': 'https://github.com/vuejs/vue-router' },
            { 'value': 'babel', 'link': 'https://github.com/babel/babel' }
          ]
        }
      },
      methods: {
        filterData: function () {
          this.dialogFormFilter = true
        },
        querySearchCb (queryString, cb) {
          var links = this.linksCb
          var results = queryString ? links.filter(this.createFilterCb(queryString)) : links
          // call callback function to return suggestions
          cb(results)
        },
        createFilterCb (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        querySearch1: function (queryString, cb) {
          var links = this.region.slice()
          var results = queryString ? links.filter(this.createFilter(queryString)) : links
          cb(results)
        },
        createFilter (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleClear () {
          console.log('clear')
        },
        handleSelect1 (item) {
          this.kode_toko = item
          // this.getData()
        },
        toMoney (x) {
          var parts = x.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          return parts.join('.')
        },
        handleChangeDate: function () {
          // this.getData()
        },
        handleFilter () {
          var byNama = this.tableData.slice(0)
          if (this.listQuery.sort === '+nama') {
            byNama.sort(function (a, b) {
              var x = a.nama.toLowerCase()
              var y = b.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.listQuery.sort === '-nama') {
            byNama.sort(function (a, b) {
              var x = b.nama.toLowerCase()
              var y = a.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else {
            byNama = this.tableData2.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData1 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          this.tableData1.push({kode: '', edit: true, nama: ''})
          for (var i = a; i < b; i++) {
            this.tableData1.push(this.tableData[i])
          }
        },
        submitForm: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('submit!')
            } else {
              console.log('error submit!!')
              return false
            }
          })
        },
        addData: function () {
          // this.tableData1.unshift({kode: '', nama: '', edit: true})
          this.dialogFormVisible = true
          this.clearForm()
        },
        clearForm: function () {
          this.row1 = {kode: '', nama: '', edit: true, tanggal_invoice: new Date(), tanggal: new Date()}
        },
        confirmDet: function (row) {
          this.$router.push('/area/' + row.kode + '/' + row.nama)
        },
        confirmEdit: function (j, row) {
          this.dialogFormEdit = true
          this.row1.kode = row.kode
          this.row1.nama = row.nama
          this.row1.id = row.id
        },
        cancelEdit: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            var item = this.tableData1[j]
            item.edit = false
            this.$set(this.tableData1, j, item)
          } else {
            this.tableData1.splice(j, 1)
          }
        },
        getData: function () {
          if (this.kode_toko === '') {
            return false
          }
          if (this.value4 === '') {
            return false
          }
          this.fullscreenLoading = true
          this.tableData = []
          this.tableData1 = []
          this.data = ''
          this.pegawaiData = []
          this.rasioData = []
          // this.chartData = ''
          // this.chartSettings = ''
          // this.bulan = moment(this.value4).format('MM')
          this.tahun = moment(this.value4).format('YYYY-MM')

          // var dataColumns = ['nama', 'total']
          var dataRows = []

          // var c = this.current_page
          var req = {kode_toko: this.kode_toko, bulan: this.tahun}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.dashboard + '/readMultiToko'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            this.fullscreenLoading = false
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.data = response.body.data[0]
              this.pegawaiData = response.body.pegawai.slice()
              this.rasioData = response.body.rasio.slice()
              dataRows = response.body.piechart.slice()
              console.log('dataRows', dataRows)
              this.chartData.rows = dataRows
              console.log('chartData', this.chartData)
              this.chartDataHistogram.rows = response.body.barchart.slice()
              this.dialogFormFilter = false
              // for (var i = 0; i < response.body.data.length; i++) {
              //   // this.data['sales_all'] = response.body.data[i].val
              //   // this.dataTemp[response.body.data[i].key] = response.body.data[i].val
              //   // alert(response.body.data[i].key)
              //   if (response.body.data[i].key === 'sales_all') {
              //     this.data.sales_all = response.body.data[i].val
              //   }
              //   // this.region[i].kode = this.region[i].kode + ''
              //   // this.region[i].value = this.region[i].nama + ''
              // }
              // // console.log(this.data['sales_all'])
              // // console.log(this.data.sales_all)
              // // this.data.push(this.dataTemp)
              // console.log(this.data)

              // this.chartData = {
              //   columns: this.data.bulanan[0].columns,
              //   rows: this.data.bulanan[0].rows
              // }
              // var settings = this.data.bulanan[0].columns.slice()
              // settings.splice(0, 1)
              // this.chartSettings = {
              //   stack: { '售价': settings },
              //   area: true
              // }
              // this.tableData = response.body.data.slice()
              // this.total = this.tableData.length
              // for (var i = 0; i < this.tableData.length; i++) {
              //   this.tableData[i].edit = false
              //   this.tableData[i].no = i + 1
              // }
              // this.tableData2 = this.tableData.slice()
              // var a = 0
              // var b = a + this.page_size
              // if (b > this.tableData.length) {
              //   b = this.tableData.length
              // }
              // for (var j = a; j < b; j++) {
              //   this.tableData1.push(this.tableData[j])
              // }
              // this.current_page = c
              // this.handleCurrentChange(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
            this.fullscreenLoading = false
            this.dialogFormFilter = false
          })
        },
        getData1: function () {
          // this.loadingModal = true
          this.tableData = []
          this.tableData1 = []
          var req = {}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/read_simple'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.toko = response.body.data.slice()
              for (var i = 0; i < this.toko.length; i++) {
                this.toko[i].value = this.toko[i].kode + ''
                this.toko[i].label = this.toko[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })

          // url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_bulanan_pilihan + '/read'
          // // console.log(localStorage.session)

          // Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
          //   // console.log('response ' + response.body[0].nama)
          //   if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
          //     this.$router.push('/login')
          //   } else {
          //     this.namas = response.body.data.slice()
          //     for (var i = 0; i < this.namas.length; i++) {
          //       this.namas[i].kode = this.namas[i].kode + ''
          //     }
          //   }
          // }, response => {
          //   // error callback
          // })
        },
        cbPilihRegion (item) {
          this.kode_toko = ''
          this.wilayah = []
          this.area = []
          this.cabang = []
          this.toko = []
          if (item.label.toString().indexOf('SEMUA TOKO') > -1) {
            this.nama_toko = item.label
            this.kode_toko = item.value
          } else {
            this.kode_region = item.value
            this.getDataWilayah()
            this.kode_area = ''
            this.kode_cabang = ''
            this.kode_toko = ''
          }
        },
        cbPilihWilayah (item) {
          this.kode_toko = ''
          this.area = []
          this.cabang = []
          this.toko = []
          console.log(item.value)
          if (item.label.toString().indexOf('SEMUA TOKO') > -1) {
            this.nama_toko = item.label
            this.kode_toko = item.value
          } else {
            this.kode_wilayah = item.value
            this.getDataArea()
            this.kode_cabang = ''
            this.kode_toko = ''
          }
        },
        cbPilihArea (item) {
          this.kode_toko = ''
          this.cabang = []
          this.toko = []
          if (item.label.toString().indexOf('SEMUA TOKO') > -1) {
            this.nama_toko = item.label
            this.kode_toko = item.value
          } else {
            this.kode_area = item.value
            this.getDataCabang()
            this.kode_toko = ''
          }
        },
        cbPilihCabang (item) {
          this.kode_toko = ''
          this.toko = []
          if (item.label.toString().indexOf('SEMUA TOKO') > -1) {
            this.nama_toko = item.label
            this.kode_toko = item.value
          } else {
            this.kode_cabang = item.value
            this.getDataToko()
          }
        },
        cbPilihToko (item) {
          this.nama_toko = item.label
          this.kode_toko = item.value
          // this.getDataToko()
        },
        getDataRegion: function () {
          var kode = localStorage.kodeLevel

          var req = {kode: kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/region'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.region = response.body.data.slice()
              for (var i = 0; i < this.region.length; i++) {
                this.region[i].value = this.region[i].kode + ''
                this.region[i].label = this.region[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        },
        getDataWilayah: function () {
          var kode = localStorage.kodeLevel
          if (this.kode_region !== '') {
            kode = this.kode_region
          }
          var req = {kode: kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/wilayah'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.wilayah = response.body.data.slice()
              for (var i = 0; i < this.wilayah.length; i++) {
                this.wilayah[i].value = this.wilayah[i].kode + ''
                this.wilayah[i].label = this.wilayah[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        },
        getDataArea: function () {
          var kode = localStorage.kodeToko
          if (this.kode_wilayah !== '') {
            kode = this.kode_wilayah
          }
          var req = {kode: kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/area'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.area = response.body.data.slice()
              for (var i = 0; i < this.area.length; i++) {
                this.area[i].value = this.area[i].kode + ''
                this.area[i].label = this.area[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        },
        getDataCabang: function () {
          var kode = localStorage.kodeLevel
          if (this.kode_area !== '') {
            kode = this.kode_area
          }
          console.log('kode=' + kode)
          var req = {kode: kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/cabang'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.cabang = response.body.data.slice()
              for (var i = 0; i < this.cabang.length; i++) {
                this.cabang[i].value = this.cabang[i].kode + ''
                this.cabang[i].label = this.cabang[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        },
        getDataToko: function () {
          // this.loadingModal = true
          // this.tableData = []
          // this.tableData1 = []

          var kode = localStorage.kodeToko
          if (this.kode_cabang !== '') {
            kode = this.kode_cabang
          }

          // if (localStorage.level.indexOf('ADMIN') > -1 || localStorage.level.indexOf('KACAB') > -1 || localStorage.level.indexOf('AM') > -1) {
          //   kode = localStorage.kodeToko
          // }

          var req = {kode: kode}
          // var req = {}
          var req1 = JSON.stringify(req)

          // var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/read_simple'
          var url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/toko'

          // if (localStorage.level.indexOf('ADMIN') > -1 || localStorage.level.indexOf('KACAB') > -1 || localStorage.level.indexOf('AM') > -1) {
          if (localStorage.level.indexOf('ADMIN') > -1 || localStorage.level.indexOf('KACAB') > -1) {
            url = Vue.cookie.get('url') + '/' + jsonUrl.combobox + '/tokoByAdmin'
          }

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.toko = response.body.data.slice()
              for (var i = 0; i < this.toko.length; i++) {
                this.toko[i].value = this.toko[i].kode + ''
                this.toko[i].label = this.toko[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        }
      },
      mounted () {
        // if (localStorage.username !== 'root') {
        //   this.$router.replace('/toko')
        // }
        // this.loadingModal = true
        // this.getData()
        // this.getData1()
        if (localStorage.level.indexOf('BOD') > -1 || localStorage.level.indexOf('KAREGION') > -1 || localStorage.level.indexOf('ROOT') > -1) {
          this.getDataRegion()
          this.getDataToko()
        }
        if (localStorage.level.indexOf('AM') > -1) { this.getDataCabang() }
        if (localStorage.level.indexOf('ADMIN') > -1 || localStorage.level.indexOf('KACAB') > -1) { this.getDataToko() }
      }
    }
</script>
<style>
  .edit-input {
    padding-right: 100px;
  }
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
  .el-tree-node__content:hover {
    background-color: #bf5377 !important;
  }
  .el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--month {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// TokoDashboard1.vue?566d294c